import { useState, useEffect } from "react";
import { Inspection } from "../../../api";
import { useAuth } from "../../../hooks";

const inspCtrl = new Inspection();

// Industria del sitio activo a los fines del Checklist (ver
// server/models/checklistSiteProfile.js) — reemplaza al antiguo
// companyIndustry, que dependía de la industria de la Empresa y no permitía
// que una misma empresa tuviera plantas de rubros distintos.
// Devuelve [industry, setIndustry]: setIndustry sólo actualiza el estado
// local (uso optimista después de guardar con setSiteIndustryProfile), no
// vuelve a pegarle al servidor.
export function useChecklistSiteIndustry(siteId) {
  const { accessToken } = useAuth();
  const [industry, setIndustry] = useState(null);

  useEffect(() => {
    if (!siteId || siteId === "0" || !accessToken) {
      setIndustry(null);
      return;
    }
    let cancelled = false;
    inspCtrl.getSiteIndustryProfile(accessToken, siteId)
      .then((profile) => { if (!cancelled) setIndustry(profile?.industry || null); })
      .catch(() => { if (!cancelled) setIndustry(null); });
    return () => { cancelled = true; };
  }, [siteId, accessToken]);

  return [industry, setIndustry];
}
